<template>
  <wb-checkbox-control class="emh-ui-checkbox" data-test-id="emh-ui-checkbox">
    <label>
      <input type="checkbox" :name="value" :checked="selected" :disabled="disabled" @change="handleChange" />
      <span class="emh-ui-checkbox__label">
        <template v-if="imageUrl">
          <img :src="imageUrl" class="emh-ui-checkbox__image" :alt="label" />
        </template>
        <template v-else>
          {{ label }}
        </template>
        <template v-if="count"> ({{ count }}) </template>
      </span>
    </label>
  </wb-checkbox-control>
</template>

<script lang="ts">
export default { name: 'UiCheckbox' };
</script>

<script lang="ts" setup>
defineProps({
  count: { type: [String, Number], default: null },
  disabled: { type: Boolean, default: false },
  imageUrl: { type: String, default: '' },
  label: { type: String, required: true },
  selected: { type: Boolean, required: true },
  value: { type: [String, Number], required: true },
});

const emit = defineEmits(['change']);

const handleChange = (event: CustomEvent<HTMLInputElement>) => {
  emit('change', event);
};
</script>

<style scoped lang="scss">
.emh-ui-checkbox {
  font-family: var(--wb-font-text);

  &__label {
    display: flex;
    align-items: center;
    min-height: 25px;
  }

  &__image {
    height: 1.5em;
  }
}
</style>
